import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import '@fortawesome/fontawesome-free/css/all.min.css';

import ReactGA from "react-ga4";
import TagManager from 'react-gtm-module';

// FacebookPixel(process.env.REACT_APP_FACEBOOK_PIXEL_ID);
ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_ID);
TagManager.initialize({ gtmId: process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);
